import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { Tabs } from "@/components/ui";
import type { TabItem } from "@/components/ui/Tabs";
import {
  callingAgentsService,
  type CallingAgent,
} from "@/services/api/callingAgents";
import CreateAgentForm from "./components/CreateAgentForm";
import { providerLabel } from "./components/useVoiceOptions";

function AddAgentPage() {
  const navigate = useNavigate();
  const [recentAgents, setRecentAgents] = useState<CallingAgent[]>([]);

  function navigateToAgentList() {
    navigate("/ai-agents");
  }

  const tabItems: TabItem[] = [
    {
      id: "manual-entry",
      label: "Manual Entry",
      content: <CreateAgentForm afterSubmit={navigateToAgentList} />,
    },
  ];

  useEffect(() => {
    callingAgentsService
      .listing({ page: 1, page_size: 5, sort: { created_at: "desc" } })
      .then((res) => {
        const list: CallingAgent[] = res?.attributes?.callingAgents ?? [];
        setRecentAgents(list);
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <h1 className="text-xl sm:text-2xl font-bold mb-4">Add AI-Agent</h1>

      <div className="flex flex-col lg:flex-row gap-4">
        {/* LEFT: form */}
        <div className="flex-1 overflow-y-auto">
          <Tabs
            items={tabItems}
            variant="underline"
            defaultActiveTab="manual-entry"
          />
        </div>

        {/* RIGHT: recently added */}
        <div className="w-full lg:w-80 p-4 border border-gray-200 rounded-lg">
          <h3 className="font-bold text-lg sm:text-xl mb-3">
            Recently Added AI-Agents
          </h3>

          <div className="space-y-3 max-h-[400px] overflow-y-auto">
            {recentAgents.length === 0 ? (
              <p className="text-sm text-gray-400">No agents yet.</p>
            ) : (
              recentAgents.map((agent) => (
                <div
                  key={agent.uuid}
                  className="border border-gray-200 rounded-lg p-3 flex justify-between items-center"
                >
                  <div className="flex items-center gap-2">
                    <UserPlus className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
                    <div>
                      <p className="font-semibold text-sm">
                        {agent.display_name}
                      </p>
                      <p className="text-xs text-gray-500">
                        {agent.settings?.first_message ?? agent.description}
                      </p>
                    </div>
                  </div>
                  <span className="px-2 py-1 rounded text-xs font-medium bg-indigo-50 text-indigo-700">
                    {providerLabel(agent.voice_provider)}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAgentPage;
